import { render, staticRenderFns } from "./interviewCPresults.vue?vue&type=template&id=38e0b463&scoped=true&"
import script from "./interviewCPresults.vue?vue&type=script&lang=js&"
export * from "./interviewCPresults.vue?vue&type=script&lang=js&"
import style0 from "./interviewCPresults.vue?vue&type=style&index=0&id=38e0b463&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e0b463",
  null
  
)

export default component.exports